import type { disponibilites as Fr } from '../fr/disponibilites';

/** « disponibilites » in English — typed on the French: a missing sentence does not compile. */
export const disponibilites: typeof Fr = {
  titre: 'Available vehicles',
  sousTitre: 'Two dates, one answer. Preparation time is already included.',
  du: 'From',
  au: 'To',
  joursFactures: (jours, tampon) => `${jours} ${jours === 1 ? 'day' : 'days'} charged · preparation buffer ${tampon} min`,
  nbLibres: (n) => `${n} ${n === 1 ? 'vehicle' : 'vehicles'} available`,
  rienDeLibre: 'Nothing available for this period',
  periode: (debut, fin) => `From ${debut} to ${fin}.`,
  libresTitre: 'Available — price calculated for the whole period',
  thVehicule: 'Vehicle',
  thImmatriculation: 'Registration',
  thCategorie: 'Category',
  thTarifJour: 'Daily rate',
  thTotalPeriode: 'Period total',
  saison: (saison) => `${({ haute: 'high', basse: 'low' } as Record<string, string>)[saison] ?? saison} season`,
  reserver: 'Book',
  prisesTitre: 'Taken — and when they become available',
  thMotif: 'Reason',
  thLibreAPartir: 'Available from',
  aucunVehicule: 'No vehicles in the fleet',
};
